<div class="free-text-container">
  <textarea class="form-control" [(ngModel)]="question.value" (ngModelChange)="onChange($event)"></textarea>
</div>